import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { CreateNewIntegration } from '../actions/integration-management-create-new.actions';
import {
  AccountIdOmniChange,
  ApiTokenOmniChange,
  CloseOmniEditIntegration,
  EditOmniIntegrationSystem,
  LookBackDaysOmniChange,
  NameOmniChange,
  NotificationEmailOmniChange,
  OmniSubmitData,
  SaveOmniConfigurationFailed,
  SaveOmniConfigurationSuccess,
  SmsSenderOmniChange,
  StatusOmniChange,
  ToggleCampaignReportingHelpTextStatus,
  ToggleCredentialsConfHelpTextStatus,
  ToggleIntegrationConfHelpTextStatus,
  ToggleNotificationHelpTextStatus,
  UpdateOmniConfigurationSuccess,
  ViberSenderOmniChange,
} from '../actions/omni-configuration.actions';

export interface OmniConfigurationState {
  nameOmni: string;
  isActiveOmni: boolean;
  smsSenderOmni: string;
  viberSenderOmni: string;
  accountIdOmni: string;
  apiTokenOmni: string;
  notificationEmailOmni: string;
  lookBackDaysOmni: number | null;
  showUpdateBtn: boolean;
  disableName: boolean;
  showCancelBtn: boolean;
  isSubmittedData: boolean;
  integrationConfHelpTextStatus: boolean;
  credentialsConfHelpTextStatus: boolean;
  notificationHelpTextStatus: boolean;
  campaignReportingHelpTextStatus: boolean;
}

const initialState: OmniConfigurationState = {
  nameOmni: '',
  isActiveOmni: false,
  smsSenderOmni: '',
  viberSenderOmni: '',
  accountIdOmni: '',
  apiTokenOmni: '',
  notificationEmailOmni: '',
  lookBackDaysOmni: 0,
  showUpdateBtn: false,
  disableName: false,
  showCancelBtn: false,
  isSubmittedData: false,
  integrationConfHelpTextStatus: false,
  credentialsConfHelpTextStatus: false,
  notificationHelpTextStatus: false,
  campaignReportingHelpTextStatus: false,
};

export const OmniConfigurationReducer = createReducer(
  initialState,
  on(NameOmniChange, (state, { nameOmni }) => ({
    ...state,
    nameOmni,
  })),
  on(StatusOmniChange, (state, { isActiveOmni }) => ({
    ...state,
    isActiveOmni,
  })),
  on(SmsSenderOmniChange, (state, { smsSenderOmni }) => ({
    ...state,
    smsSenderOmni,
  })),
  on(ViberSenderOmniChange, (state, { viberSenderOmni }) => ({
    ...state,
    viberSenderOmni,
  })),
  on(AccountIdOmniChange, (state, { accountIdOmni }) => ({
    ...state,
    accountIdOmni,
  })),
  on(ApiTokenOmniChange, (state, { apiTokenOmni }) => ({
    ...state,
    apiTokenOmni,
  })),
  on(NotificationEmailOmniChange, (state, { notificationEmailOmni }) => ({
    ...state,
    notificationEmailOmni,
  })),
  on(LookBackDaysOmniChange, (state, { lookBackDaysOmni }) => ({
    ...state,
    lookBackDaysOmni,
  })),
  on(ToggleIntegrationConfHelpTextStatus, (state) => ({
    ...state,
    integrationConfHelpTextStatus: !state.integrationConfHelpTextStatus,
  })),
  on(ToggleCredentialsConfHelpTextStatus, (state) => ({
    ...state,
    credentialsConfHelpTextStatus: !state.credentialsConfHelpTextStatus,
  })),
  on(ToggleNotificationHelpTextStatus, (state) => ({
    ...state,
    notificationHelpTextStatus: !state.notificationHelpTextStatus,
  })),
  on(ToggleCampaignReportingHelpTextStatus, (state) => ({
    ...state,
    campaignReportingHelpTextStatus: !state.campaignReportingHelpTextStatus,
  })),
  on(OmniSubmitData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(SaveOmniConfigurationSuccess, (state, { res }) => ({
    ...state,
    showUpdateBtn: true,
    disableName: true,
    nameOmni: res.payload.data.integrationConfig.integrationDisplayName,
    isActiveOmni: res.payload.data.deleted,
    smsSenderOmni: res.payload.data.integrationConfig.smsSender,
    viberSenderOmni: res.payload.data.integrationConfig.viberSender,
    accountIdOmni: res.payload.data.integrationConfig.accountId,
    apiTokenOmni: res.payload.data.endpointConfiguration.credentialConfig.token,
    notificationEmailOmni: res.payload.data.integrationConfig.executionNotificationReceiver,
    lookBackDaysOmni: res.payload.data.integrationConfig.reportingConfiguration.lookbackDays,
    integrationConfHelpTextStatus: false,
    credentialsConfHelpTextStatus: false,
    notificationHelpTextStatus: false,
    campaignReportingHelpTextStatus: false,
    isSubmittedData: false,
  })),
  on(SaveOmniConfigurationFailed, (state) => ({
    ...state,
    showUpdateBtn: false,
    disableName: false,
  })),
  on(UpdateOmniConfigurationSuccess, (state, { res }) => ({
    ...state,
    showUpdateBtn: true,
    disableName: true,
    nameOmni: res.payload.data.integrationConfig.integrationDisplayName,
    isActiveOmni: res.payload.data.deleted,
    smsSenderOmni: res.payload.data.integrationConfig.smsSender,
    viberSenderOmni: res.payload.data.integrationConfig.viberSender,
    accountIdOmni: res.payload.data.integrationConfig.accountId,
    apiTokenOmni: res.payload.data.endpointConfiguration.credentialConfig.token,
    notificationEmailOmni: res.payload.data.integrationConfig.executionNotificationReceiver,
    lookBackDaysOmni: res.payload.data.integrationConfig.reportingConfiguration.lookbackDays,
  })),
  on(EditOmniIntegrationSystem, (state, { omniData }) => ({
    ...state,
    nameOmni: omniData.integrationConfig.integrationDisplayName,
    isActiveOmni: omniData.deleted,
    smsSenderOmni: omniData.integrationConfig.smsSender,
    viberSenderOmni: omniData.integrationConfig.viberSender,
    accountIdOmni: omniData.integrationConfig.accountId,
    apiTokenOmni: omniData.endpointConfiguration.credentialConfig.token,
    notificationEmailOmni: omniData.integrationConfig.executionNotificationReceiver,
    lookBackDaysOmni: omniData.integrationConfig.reportingConfiguration.lookbackDays,
    showUpdateBtn: true,
    disableName: true,
    showCancelBtn: true,
    isSubmittedData: false,
  })),
  on(CreateNewIntegration, (state) => ({
    ...state,
    nameOmni: '',
    isActiveOmni: false,
    smsSenderOmni: '',
    viberSenderOmni: '',
    accountIdOmni: '',
    apiTokenOmni: '',
    notificationEmailOmni: '',
    lookBackDaysOmni: 0,
    showUpdateBtn: false,
    disableName: false,
    showCancelBtn: false,
    integrationConfHelpTextStatus: false,
    credentialsConfHelpTextStatus: false,
    notificationHelpTextStatus: false,
    campaignReportingHelpTextStatus: false,
    isSubmittedData: false,
  })),
  on(CloseOmniEditIntegration, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
